import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { finalize } from "rxjs";
import { Calibration } from "src/app/models/Calibration";
import { ScheduleServiceInterval } from "src/app/models/ScheduleServiceInterval";
import { Tool } from "src/app/models/Tool";
import { ToolUpdate } from "src/app/models/ToolUpdate";
import { ModalComponent, ModalService } from "src/app/services/modal.service";
import { ToolService } from "src/app/services/tool.service";

import { ScheduleService } from "./../../services/schedule.service";

export type CalibrationModalData = {
  tool: Tool;
  calibration: Calibration;
};

type CalibrationStatus = {
  id: string;
  title: string;
};

@Component({
  selector: "app-calibration-modal",
  templateUrl: "./calibration-modal.component.html",
  styleUrls: ["./calibration-modal.component.scss"],
  standalone: false,
})
export class CalibrationModalComponent
  implements OnInit, ModalComponent<CalibrationModalComponent, CalibrationModalData>
{
  faSpinner = faSpinner;
  isLoading: boolean;
  frequencyList: number[];
  tool: Tool;
  calibration: Calibration;
  intervals: ScheduleServiceInterval[];
  calibrationStatuses: CalibrationStatus[];

  constructor(
    private toolService: ToolService,
    public modalService: ModalService,
    private scheduleService: ScheduleService,
    @Inject(MAT_DIALOG_DATA) public data: CalibrationModalData,
    public dialogRef: MatDialogRef<CalibrationModalComponent, void>,
  ) {}

  ngOnInit() {
    this.tool = this.data.tool;
    this.calibration = Object.assign({}, this.data.calibration);
    this.setCalFrequencyList();
    this.intervals = this.scheduleService.intervals;
    this.calibrationStatuses = this.scheduleService.calibrationStatuses;
  }

  updateCalibration() {
    this.isLoading = true;
    this.toolService
      .updateCalibrationSchedule(
        this.tool.companyId,
        this.tool.serialNumber,
        new ToolUpdate({
          calibrationNext: this.calibration.nextDate,
          calibrationFrequency: this.calibration.frequency,
          calibrationInterval: this.calibration.interval,
          calibrationStatus: this.calibration.calibrationStatus,
        }),
      )
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe(() => {
        this.data.calibration.nextDate = this.calibration.nextDate;
        this.data.calibration.interval = this.calibration.interval;
        this.data.calibration.frequency = this.calibration.frequency;
        this.data.calibration.calibrationStatus = this.calibration.calibrationStatus;
        this.data.calibration.localizedInterval = this.intervals.find(
          (x) => x.id === this.calibration.interval,
        ).localizedTitle;

        this.modalService.close();
      });
  }

  setCalFrequencyList() {
    this.frequencyList = this.scheduleService.getFrequencyList(this.calibration.interval);
    this.setFrequency();
    this.refreshNextScheduleDate();
  }

  setFrequency() {
    if (!this.frequencyList) return;

    if (!this.calibration.frequency) {
      this.calibration.frequency = 1;
      return;
    }

    if (this.calibration.frequency > Math.max(...this.frequencyList))
      this.calibration.frequency = Math.max(...this.frequencyList);
  }

  refreshNextScheduleDate() {
    this.calibration.nextDate = this.scheduleService.getNextScheduleDate(
      this.calibration.interval,
      this.calibration.frequency,
      this.calibration.lastDate,
    );
  }
}
